import { useQuery } from '@src/shared/query';
import { useMemo } from 'react';
import { selectAbsenceTypes } from '../../lib';
import { absenceTypeParams, typesUrl } from './constants';

type UseAbsenceTypesOptions = {
  editableForUserId?: number | null;
};

export default function useAbsenceTypes({
  editableForUserId,
}: UseAbsenceTypesOptions = {}) {
  const queryParams = useMemo(
    () => ({
      ...absenceTypeParams,
      ...(editableForUserId
        ? { editable_for_user: String(editableForUserId) }
        : {}),
    }),
    [editableForUserId],
  );

  const { data: absenceTypes = [], ...restQuery } = useQuery(typesUrl, {
    queryParams,
    select: selectAbsenceTypes,
  });

  return {
    absenceTypes,
    ...restQuery,
  };
}
